var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73535 15.0391V0.988281C4.73535 0.726562 4.52441 0.515625 4.25879 0.515625H1.46191C1.19629 0.515625 0.985352 0.726562 0.985352 0.988281V15.0391C0.985352 15.3008 1.19629 15.5156 1.46191 15.5156H4.25879C4.52441 15.5156 4.73535 15.3047 4.73535 15.0391Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5088 0.515625H7.71191C7.4502 0.515625 7.23535 0.726562 7.23535 0.988281V15.0391C7.23535 15.3008 7.44629 15.5156 7.71191 15.5156H10.5088C10.7705 15.5156 10.9854 15.3047 10.9854 15.0391V0.988281C10.9854 0.726562 10.7744 0.515625 10.5088 0.515625Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdle);
export default __webpack_public_path__ + "static/media/idle.316bfe8508cc8c1cfca37db240f64a29.svg";
export { ForwardRef as ReactComponent };